"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;


//////////////////
// WEBPACK FOOTER
// ./~/recompose/setStatic.js
// module id = 97
// module chunks = 35783957827783 153662236231701 175947910196865